module.exports = __webpack_public_path__ + "static/img/rural.abb59cd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bank/rural.jpg
// module id = nEm+
// module chunks = 1